module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/bg-light-b7554ea5fbc1bf969f220bb529c98176.png";